import moment from 'moment';
import {
  NoSessionError,
  SessionExpiredError,
  LoadDataError
} from 'constants/errors';

const SessionManager = {
  start: (expires = 2) => {
    if (sessionStorage.getItem('expires') != null) {
      return;
    }

    sessionStorage.setItem(
      'expires',
      moment()
        .add(expires, 'hour')
        .format()
    );
  },
  save: value => {
    sessionStorage.setItem('data', JSON.stringify(value));
  },
  saveCompletionData: value => {
    sessionStorage.setItem('completion_data', JSON.stringify(value));
  },
  load: () => {
    const expires = sessionStorage.getItem('expires');

    if (expires == null) {
      sessionStorage.removeItem('data');
      throw NoSessionError;
    }

    if (moment() > moment(expires)) {
      sessionStorage.removeItem('expires');
      sessionStorage.removeItem('data');
      throw SessionExpiredError;
    }

    const data = sessionStorage.getItem('data');

    if (data == null) {
      throw LoadDataError;
    }

    return JSON.parse(data);
  },
  loadCompletionData: () => {
    const expires = sessionStorage.getItem('expires');
    if (expires == null) {
      sessionStorage.removeItem('completion_data');
      throw NoSessionError;
    }
    if (moment() > moment(expires)) {
      sessionStorage.removeItem('expires');
      sessionStorage.removeItem('completion_data');
      throw SessionExpiredError;
    }

    const data = sessionStorage.getItem('completion_data');
    if (data == null) {
      return null;
    }
    return JSON.parse(data);
  },
  clear: () => {
    sessionStorage.removeItem('expires');
    sessionStorage.removeItem('data');
    sessionStorage.removeItem('completion_data');
  }
};

SessionManager.saveCompletionDataLogic = val => {
  sessionStorage.removeItem('expires');
  SessionManager.start(99);
  SessionManager.saveCompletionData(val);
};

export default SessionManager;



// WEBPACK FOOTER //
// ./src/util/session-manager.js